import type IUnitLinkItem from 'components/UnitLinkField/interfaces/IUnitLinkItem';
import type { IRecordRefsResponse } from 'store/slices/dataSets/interfaces/IRecordRefsResponse';
import type ISupplierLink from 'store/slices/dataSets/interfaces/ISupplierLink';
import type IUnitRef from './interfaces/IUnitRef';

// Different record types may share a uid, so a link is only identified by both.
export const buildUnitLinkKey = ({ relationType, relationUID }: ISupplierLink) => (
  `${relationType}:${relationUID}`
);

export const recordRefsToUnitRefs = (
  response: IRecordRefsResponse | undefined,
  type: string,
): IUnitRef[] => Object.entries(response?.data || {})
  .map(([uid, {
    label, profitCentreUIDs, unitId, subtype,
  }]) => ({
    uid,
    label,
    type,
    profitCentreUIDs: profitCentreUIDs || [],
    unitId: unitId ?? null,
    // Passed through untouched: absent must stay absent rather than collapsing to null, which
    // would claim a supplier had been checked for factory-ness and found not to be one.
    subtype,
  }))
  // The payload is an object, so its order carries no meaning — impose one for display.
  .sort((first, second) => first.label.localeCompare(second.label));

export const filterRefsByProfitCentre = (
  refs: IUnitRef[],
  profitCentreUID?: string,
): IUnitRef[] => {
  if (!profitCentreUID) {
    return refs;
  }

  return refs.filter((ref) => ref.profitCentreUIDs.includes(profitCentreUID));
};

export const unitRefsToItems = (refs: IUnitRef[]): IUnitLinkItem[] => refs.map((ref) => ({
  itemKey: buildUnitLinkKey({ relationUID: ref.uid, relationType: ref.type }),
  name: ref.label,
  type: ref.type,
}));
